//封装网络请求模块
//导入vue实例，使用$store
import axios from "axios";
import {
	Message
} from 'element-ui'
import Vue from "vue";
let baseURLSever = window.localStorage.getItem("domainGongDan")
let baseURL = window.localStorage.getItem("domainGongDan")

// let baseURLSever = "http://gdapi.zzskzy.com/" //正式环境
// let baseURL = "http://gdapi.zzskzy.com/"
// let baseURLSever = "http://123.161.211.74:8059/" //测试环境
// let baseURL = "http://123.161.211.74:8059/"

if (process.env.NODE_ENV == 'development') {
	baseURL = "/api" // 请求接口代理路径
}
axios.defaults.baseURL = baseURL;
axios.defaults.timeout = 55000;

/**
 * 可以新建多个axios实例
 * 在项目使用多个请求地址时方便使用
 */
//导出第一个axios实例
function requestbody (config) {
	let instence = axios.create({
		headers: {
			'Authorization': localStorage.getItem('Token') || '', //写自己后端传回来的token的命名，本项目为 authorization，

			"Content-Type": "application/json, text/json",
		},
	});

	instence.interceptors.request.use(function (res) {
		//在这里可以统一将参数放在请求体data中
		res.data = config.param;

		Vue.showLoading();
		return res;
	}, function (err) {
		// loadingInstance.close();
		Vue.hideLoading();
		return err
	});

	instence.interceptors.response.use(function (res) {
		//响应成功
		//关闭loading
		Vue.hideLoading();
		switch (res.status) {
			case 200:
				// if (res.data.Msg_code == "0") {
				//   return Promise.resolve(res.data)
				// } else {
				//   Message({
				//     // message: res.data,
				//     message: "程序错误，请联系管理员！",
				//     type: 'error'
				//   });
				//   return Promise.reject(res.data)
				// }
				if (res.data.Code == '0' || res.data.Code == 0 || res.data.Code == '5' || res.data.Code == 5) {
					return Promise.resolve(res.data)
				} else {
					Message({
						message: res.Msg,
						type: 'error'
					});
					return Promise.reject(res.data)
				}
			case 404:
				Message({
					message: "资源无法找到",
					type: 'error'
				});
				return Promise.reject(res)
			case 500:
				Message({
					message: "服务器错误",
					type: 'error'
				});
				return Promise.reject(res)
			default:
				return Promise.reject(res.Msg)
		}
	}, function (err) {
		// loadingInstance.close();
		Vue.hideLoading();

		if (err == "Error: Request failed with status code 401") {
			if (document.getElementsByClassName('el-message').length === 0) {
				Message({
					message: "登录过期，请重新登录",
					type: 'error',
					maxCount: 1 // 最大显示数, 超过限制时，最早的消息会被自动关闭

				});
			}

		} else if (err == "Error: Request failed with status code 412") {

			Message({
				message: "参数异常",
				type: 'error'
			});
		} else {
			Message({
				message: err,
				type: 'error'
			});

		}
		return Promise.reject(err)
	});

	return instence(config)
}
//导出第一个axios实例
function requesta (config) {
	return new Promise((resolve, reject) => {


		axios({
			url: config.url,
			method: config.method,
			headers: {
				'Authorization': localStorage.getItem('Token') ||
					'', //写自己后端传回来的token的命名，本项目为 authorization，
			},
			data: config.data
		}).then(res => {
			if (res.status == 200) {

				if (res.data.Code == '0' || res.data.Code == 0 || res.data.Code == '5' || res.data
					.Code == 5) {
					resolve(res.data)
				} else {
					Message({
						message: res.data.Msg,
						type: 'error'
					});
					reject(res.data)
				}
			} else if (res.status == 404) {
				Message({
					message: "资源无法找到",
					type: 'error'
				});
				reject(res)
			} else if (res.status == 401) {
				if (document.getElementsByClassName('el-message').length === 0) {
					Message({
						message: "请重新登录",
						type: 'error'
					});
				}

				reject(res)
			} else if (res.status == 500) {
				Message({
					message: "服务器错误",
					type: 'error'
				});
				reject(res)
			} else {

				reject(res)
			}

			// resolve(res)
		}).catch(err => {
			if (err == "Error: Request failed with status code 401") {
				if (document.getElementsByClassName('el-message').length === 0) {
					Message({
						message: "登录过期，请重新登录",
						type: 'error'
					});
				}

			} else if (err == "Error: Request failed with status code 412") {

				Message({
					message: "参数异常",
					type: 'error'
				});
			} else {
				Message({
					message: err,
					type: 'error'
				});

			}

			reject(err)
		})
	})
}
//导出第一个axios实例
function request (config) {
	console.log("config", config)
	return new Promise((resolve, reject) => {


		axios({
			url: config.url,
			method: config.method,
			headers: {
				"Content-Type": "application/json",
				'Authorization': localStorage.getItem('Token') ||
					'', //写自己后端传回来的token的命名，本项目为 authorization，
			},
			"Content-Type": "application/json",
			data: config.data
		}).then(res => {
			if (res.status == 200) {

				if (res.data.Code == '0' || res.data.Code == 0 || res.data.Code == '5' || res.data
					.Code == 5) {
					resolve(res.data)
				} else {
					Message({
						message: res.data.Msg,
						type: 'error'
					});
					reject(res.data)
				}
			} else if (res.status == 404) {
				Message({
					message: "资源无法找到",
					type: 'error'
				});
				reject(res)
			} else if (res.status == 401) {
				if (document.getElementsByClassName('el-message').length === 0) {
					Message({
						message: "请重新登录",
						type: 'error'
					});
				}

				reject(res)
			} else if (res.status == 500) {
				Message({
					message: "服务器错误",
					type: 'error'
				});
				reject(res)
			} else {

				reject(res)
			}

			// resolve(res)
		}).catch(err => {
			if (err == "Error: Request failed with status code 401") {
				if (document.getElementsByClassName('el-message').length === 0) {
					Message({
						message: "登录过期，请重新登录",
						type: 'error'
					});
				}

			} else if (err == "Error: Request failed with status code 412") {

				Message({
					message: "参数异常",
					type: 'error'
				});
			} else {
				Message({
					message: err,
					type: 'error'
				});

			}

			reject(err)
		})
	})
}

function getBaseUrl () {
	axios({
		baseURL: "./",
		url: "config.json",
		method: "get",
	})
		.then((res) => {
			if (res.data.baseURL) {
				//将请求地址存放
				window.localStorage.setItem("domainGongDan", res.data.baseURL);
				axios.defaults.baseURL = res.data.baseURL;
				console.log("请求地址修改成功axios.defaults.baseURL", axios.defaults.baseURL);
			} else {
				Message({
					message: "未添加baseURL地址!",
					type: "error",
				});
			}
		
		})
		.catch((err) => {
			console.log(err);
			Message({
				message: "本地网络设置配置发生错误!",
				type: "error",
			});
		});
}

export {
	getBaseUrl,
	requestbody,
	request,
	requesta,
	baseURLSever,
}
